<template>
  <div v-if="usuario.id_funcao < 3">
    <div class="mb-3" v-if="!isComponente">
      <router-link to="/home" class="btn btn-outline-dark"><i class="fa fa-chevron-left mr-1"></i> Voltar</router-link>
    </div>
    <div class="row no-gutters justify-content-end align-items-center mb-3 mb-xl-0" v-if="usuario.admin">
      <div class="col-xl-2 col-md-3 mb-1 pr-md-2">
        <select class="form-control" v-model="pesquisa.range" @change="changeRange()" :disabled="menu > 2">
          <option value="1">Hoje</option>
          <option value="2">Ontem</option>
          <option value="3">Últimos 7 dias</option>
          <option value="4">Mês atual</option>
          <option value="5">Mês passado</option>
          <option value="6">Últimos 3 Meses</option>
          <option value="99">Por dia</option>
          <option value="0">Por Intervalo</option>
        </select>
      </div>
      <div class="col-lg-1 col-md-3 mb-2" v-if="pesquisa.range === '1' && cache_date">
        <a href="javascript:" class="btn btn-primary btn-block" @click="iniciar()" title="Sincronizar dados">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-rotate" width="22" height="22" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5"/>
          </svg>
        </a>
      </div>
      <div class="col-md-3 col-xl-2 mb-1 pr-md-2" v-if="['0','99'].includes(pesquisa.range)">
        <input class="form-control" type="date" v-model="pesquisa.dt_inicio" @change="changeRange()">
      </div>
      <div class="col-md-3 col-xl-2 mb-1 pr-md-2" v-if="pesquisa.range === '0'">
        <input class="form-control" type="date" v-model="pesquisa.dt_fim" @change="changeRange()">
      </div>
      <div class="col-lg-1 col-md-3 mb-2" v-if="pesquisa.range === '0'">
        <button class="btn btn-warning btn-block" @click="changeRange(true)"><i class="fa fa-search"></i></button>
      </div>
    </div>
    <modal-menu :menus="menus" :selected="menu" @changeMenu="changeMenu"/>
    <div class="text-right" v-if="menu === 1">
      <button class="btn btn-sm btn-outline-dark" @click="ocultarInfos()" style="width: 92px">
        <i class="fa" :class="!ocultar ? 'fa-eye-slash' : 'fa-eye'"></i><span class="ml-2">{{ocultar ? 'Mostrar' : 'Ocultar'}}</span>
      </button>
    </div>
    <div class="mt-3" v-if="menu === 1">
      <div class="alert alert-warning d-flex align-items-center small" v-if="!ocultar && pesquisa.range === '1' && menu === 1" style="line-height: 1.1rem">
        <i class="fa fa-exclamation-triangle text-warning mr-2"></i>
        <div><b>Exibindo valores parciais.</b> Caso existam vendas em aberto, feche-as para obter o valor final.</div>
      </div>
      <div class="row justify-content-center">
        <div class="mb-3" :class="pesquisa.range === '1' && usuario.admin ? 'col-md-6 col-xl-3' : 'col-md-4'">
          <div class="card shadow-sm">
            <div class="card-body d-flex align-items-center justify-content-between">
              <div>
                <div class="text-primary small">
                  TOTAL DE VENDAS
                  <tooltip :msg="`Total de vendas iniciadas no período ${pesquisa.range === '1' ? '(valores parciais).' : '(fechadas).'}`"/>
                </div>
                <div v-if="ocultar">
                  <h6 class="h5 font-weight-bold my-1">R$ <i class="fa fa-circle icon-dot" v-for="i in 4"></i></h6>
                  <div class="text-muted small">Nº Vendas</div>
                </div>
                <div v-else>
                  <div class="d-flex align-items-center">
                    <h6 class="h5 font-weight-bold my-1">{{ (diario.valor || 0) | valor}}</h6>
                    <span v-if="diario.percent" class="ml-2" :class="diario.percent < 0 ? 'text-danger' : 'text-success'" style="font-size: 12px" title="Vs período anterior">
                    <i class="fa" :class="diario.percent < 0 ? 'fa-angle-down' : 'fa-angle-up'"></i>
                    {{diario.percent}}%
                  </span>
                  </div>
                  <div class="text-muted small">Nº Vendas: {{ diario.qtd || 0 }}</div>
                </div>
              </div>
              <i class="fas fa-dollar-sign text-primary"></i>
            </div>
          </div>
        </div>
        <div class="mb-3" :class="pesquisa.range === '1' && usuario.admin ? 'col-md-6 col-xl-3' : 'col-md-4'">
          <div class="card shadow-sm">
            <div class="card-body d-flex align-items-center justify-content-between">
              <div>
                <div class="text-warning small">
                  TICKET MÉDIO
                  <tooltip msg="Valor médio gasto nos pedidos: quanto maior for o valor, mais os clientes estão gastando nos pedidos. É o indicador que mostra o comportamento do cliente com a marca e também pode ser relacionado à satisfação com a empresa."/>
                </div>
                <h6 class="h5 font-weight-bold my-1" v-if="ocultar">R$ <i class="fa fa-circle icon-dot" v-for="i in 4"></i></h6>
                <div class="d-flex align-items-center" v-else>
                  <h6 class="h5 font-weight-bold my-1">{{ (diario.ticket || 0) | valor}}</h6>
                  <span v-if="diario.ticketPercent" class="ml-2" :class="diario.ticketPercent < 0 ? 'text-danger' : 'text-success'" title="Vs período anterior" style="font-size: 12px">
                    <i class="fa" :class="diario.ticketPercent < 0 ? 'fa-angle-down' : 'fa-angle-up'"></i>
                    {{diario.ticketPercent}}%
                  </span>
                </div>
                <div class="text-muted small">Média por venda</div>
              </div>
              <i class="fas fas fa-ticket-alt text-warning"></i>
            </div>
          </div>
        </div>
        <div class="mb-3" :class="pesquisa.range === '1' && usuario.admin ? 'col-md-6 col-xl-3' : 'col-md-4'">
          <div class="card shadow-sm">
            <div class="card-body d-flex align-items-center justify-content-between">
              <div>
                <div class="small text-success">
                  TAXAS DE ENTREGA
                  <tooltip msg="Total das taxas de entrega somadas no período, excluindo os pedidos com entrega gratuita."/>
                </div>
                <div v-if="ocultar">
                  <h6 class="h5 font-weight-bold my-1">R$ <i class="fa fa-circle icon-dot" v-for="i in 4"></i></h6>
                  <div class="text-muted small">Nº de taxas</div>
                </div>
                <div v-else>
                  <h6 class="h5 font-weight-bold my-1">{{ (frete.valor || 0) | valor}}</h6>
                  <div class="text-muted small">Nº de taxas: {{ frete.qtd || 0 }}</div>
                </div>
              </div>
              <i class="fa fa-motorcycle text-success"></i>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-xl-3 mb-3" v-if="pesquisa.range === '1' && usuario.admin">
          <div class="card shadow-sm">
            <div class="card-body d-flex align-items-center justify-content-between">
              <div v-if="ocultar">
                <div class="small text-dark">PROJEÇÃO DO MÊS</div>
                <h6 class="h5 font-weight-bold my-1">R$ <i class="fa fa-circle icon-dot" v-for="i in 4"></i></h6>
                <div class="text-muted small">Nº Vendas</div>
              </div>
              <div v-else>
                <div class="small text-dark">PROJEÇÃO DO MÊS</div>
                <h6 class="h5 font-weight-bold my-1">{{ (projecao.valor || 0) | valor}}</h6>
                <div class="text-muted small">Nº Vendas: {{ projecao.qtd }}</div>
              </div>
              <i class="fa fa-chart-line"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="!ocultar">
        <div class="col-lg-6 mb-4 mb-lg-0">
          <div class="card shadow-sm overflow-hidden">
            <div class="card-header bg-white py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 class="m-0 font-weight-bold text-primary">Operação</h6>
            </div>
            <div class="card-body pl-2">
              <div style="min-height: 300px">
                <div style="height: 265px">
                  <tipo-pedido :height="265" :dados="tipoComandas" :pedidos="tipoPedidos" v-if="tipoComandas.length"/>
                </div>
                <div class="mt-4 text-center small">
                  <span class="mr-2 text-nowrap"><i class="fas fa-circle text-primary"></i> Mesas</span>
                  <span class="mr-2 text-nowrap"><i class="fas fa-circle text-success"></i> Delivery</span>
                  <span class="mr-2 text-nowrap"><i class="fas fa-circle text-warning"></i> Comandas</span>
                  <span class="mr-2 text-nowrap"><i class="fas fa-circle text-third"></i> Venda Rápida</span>
                  <span class="mr-2 text-nowrap"><i class="fas fa-circle text-info"></i> Balcão</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="card shadow-sm overflow-hidden">
            <div class="card-header bg-white py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 class="m-0 font-weight-bold text-primary">Pagamentos</h6>
            </div>
            <div class="card-body pl-2">
              <div style="min-height: 265px">
                <vendas-pagamento :height="265" :dados="pagamentos" v-if="pagamentos.length"/>
              </div>
              <div class="img-pagamento">
                <span class="w-100 text-center d-block" v-for="p in pagamentos">
                  <img :src="p.img_pagamento" alt="Pagamento" v-if="p.img_pagamento">
                  <i class="fa fa-credit-card" style="font-size: 12px" v-else></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 mt-4" v-show="pesquisa.range === '4'">
          <div class="card shadow-sm overflow-hidden">
            <div class="card-header bg-white py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 class="m-0 font-weight-bold text-primary">Desempenho de vendas</h6>
            </div>
            <div class="card-body pl-2">
              <div style="height: 252px">
                <comparativo-periodo :height="265" :dados="comparativoPorPeriodo"/>
              </div>
              <div class="mt-4 text-center small">
                <span class="mr-2 text-nowrap"><i class="fas fa-circle text-primary"></i> Mês atual</span>
                <span class="mr-2 text-nowrap"><i class="fas fa-circle text-secondary"></i> Mês anterior</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 mt-4" v-show="pesquisa.range === '6'">
          <div class="card shadow-sm overflow-hidden">
            <div class="card-header bg-white py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 class="m-0 font-weight-bold text-primary">Desempenho de vendas</h6>
            </div>
            <div class="card-body pl-2">
              <div style="height: 252px">
                <vendas-periodo :height="265" :dados="vendasPorPeriodo" periodo="3"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="menu === 2">
      <div class="col-lg-6">
        <div class="card shadow-sm mb-4 mb-lg-0 overflow-auto card-categorias">
          <table class="table table-striped rounded mb-0">
            <tr class="text-primary" style="height: 64px">
              <th class="align-middle">Categorias</th>
              <th class="text-center" style="width: 20%">&nbsp;</th>
            </tr>
            <tbody class="small" v-if="vCategorias.length">
            <tr v-for="(c, index) in vCategorias">
              <td class="d-flex align-items-center">
                <b class="ml-2 mr-3">{{index + 1 }}</b>
                <icon-categoria :name="c.slug ? c.slug : 'default'" size="40" class="mr-3"/>
                {{ c.nome_categoria }}
              </td>
              <td class="text-right pr-4 text-nowrap">{{ c.qtd | fixed }}</td>
            </tr>
            </tbody>
            <tbody class="small" v-else>
            <tr>
              <td colspan="3">
                <div class="d-flex align-items-center justify-content-center" style="height: 300px">
                  <div class="text-center" v-if="!loadCategorias">
                    Não houve vendas neste dia!
                  </div>
                  <loading v-else/>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card shadow-sm overflow-auto card-categorias">
          <table class="table rounded mb-0 table-striped">
            <tr class="text-primary" style="height: 64px">
              <th class="align-middle">Mais vendidos</th>
              <th class="align-middle py-1" style="width: 202px">
                <select class="form-control" v-model="pesquisa.id_categoria" @change="maisVendidos()">
                  <option value="">Todas categorias</option>
                  <option :value="c.id_categoria" v-for="c in categorias">{{ c.nome_categoria }}</option>
                </select>
              </th>
            </tr>
            <tbody class="small" v-if="produtos.length">
              <tr v-for="(p, index) in produtos">
                <td class="d-flex align-items-center">
                  <b class="ml-2 mr-4">{{index + 1 }}</b>
                  <img :src="p.url_imagem || (base_cdn + '/lecard-corporativo/static/imgs/default.png')"
                       class="rounded mr-3 bg-primary" style="height: 40px; width: 52px; object-fit: cover"> {{p.nome_produto}}
                </td>
                <td class="text-right pr-4 text-nowrap">{{ p.qtd | fixed }}</td>
              </tr>
            </tbody>
            <tbody class="small" v-else>
              <tr>
                <td colspan="3">
                  <div class="d-flex align-items-center justify-content-center" style="height: 300px">
                    <div class="text-center" v-if="!loadProdutos">
                      Não houve vendas neste dia!
                    </div>
                    <loading v-else/>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-show="menu === 3">
      <div class="row no-gutters align-items-end mb-3 d-print-none">
        <div class="col-xl-2 col-md-3 mb-1 pr-md-2">
          <label class="mb-0 font-weight-bold small">Status</label>
          <select class="form-control" v-model="pesquisa.status" @change="getDebitos()">
            <option value="1">Abertos</option>
            <option value="3">Atrasados</option>
            <option value="2">Pagos</option>
          </select>
        </div>
        <div class="col-xl-2 col-md-3 mb-1 pr-md-2" v-show="pesquisa.status !== '3'">
          <label class="mb-0 font-weight-bold small">Data de:</label>
          <input class="form-control" type="date" v-model="pesquisa.dt_inicio">
        </div>
        <div class="col-xl-2 col-md-3 mb-1 pr-md-2" v-show="pesquisa.status !== '3'">
          <label class="mb-0 font-weight-bold small">Data até:</label>
          <input class="form-control" type="date" v-model="pesquisa.dt_fim">
        </div>
        <div class="col-xl-3 col-md-3 mb-1">
          <div class="row no-gutters">
            <div class="col-md-6 pr-md-1 my-2 my-md-0">
              <button class="btn btn-warning btn-block" title="Pesquisar" @click="getDebitos()">
                <i class="fa fa-search"></i>
                <span class="ml-2 d-md-none">Pesquisar</span>
              </button>
            </div>
            <div class="col-md-6 pl-md-1">
              <button :disabled="!debitos.length" class="btn btn-third btn-block" title="imprimir" @click="imprimirDebitos()">
                <i class="fa fa-print"></i>
                <span class="ml-2 d-md-none">Imprimir</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center" v-if="usuario.admin">
        <div class="col-md-4 mb-3">
          <div class="card shadow-sm">
            <div class="card-body d-flex align-items-center justify-content-between">
              <div>
                <div class="text-success small">RECEBIDOS</div>
                <div class="d-flex align-items-center">
                  <h6 class="h5 font-weight-bold my-1">{{ (totaisDebitos.recebidos.valor_recebido || 0) | valor}}</h6>
                </div>
                <div class="text-muted small">Nº Débitos: {{ totaisDebitos.recebidos.qtd || 0 }}</div>
              </div>
              <i class="fas fa-dollar-sign text-success"></i>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-3">
          <div class="card shadow-sm">
            <div class="card-body d-flex align-items-center justify-content-between">
              <div>
                <div class="text-primary small">A RECEBER</div>
                <div class="d-flex align-items-center">
                  <h6 class="h5 font-weight-bold my-1">{{ (totaisDebitos.areceber.valor || 0) | valor}}</h6>
                </div>
                <div class="text-muted small">Nº Débitos: {{ totaisDebitos.areceber.qtd || 0 }}</div>
              </div>
              <i class="fas fa-dollar-sign text-primary"></i>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-3">
          <div class="card shadow-sm">
            <div class="card-body d-flex align-items-center justify-content-between">
              <div>
                <div class="text-secondary small">ATRASADOS</div>
                <div class="d-flex align-items-center">
                  <h6 class="h5 font-weight-bold my-1">{{ (totaisDebitos.atrasados.valor || 0) | valor}}</h6>
                </div>
                <div class="text-muted small">Nº Débitos: {{ totaisDebitos.atrasados.qtd || 0 }}</div>
              </div>
              <i class="fas fa-dollar-sign text-secondary"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="card shadow-sm">
        <div class="card-body table-responsive" style="min-height: 300px" v-show="debitos.length">
          <div id="relatorioDebitos">
            <div class="text-center hide">
              <b>{{ usuario.nome_fantasia }}</b>
              <div>Comprovante de Débitos</div>
              <hr>
            </div>
            <div>
              <div class="debito-list" v-for="(p, index) in debitos" :key="index" @click="abrirDebito(p)">
                <b class="mb-1">{{p.nome_cliente}}</b> <span class="small" v-if="p.telefone"> {{p.telefone | phone}}</span>
                <div v-for="d in p.debitos" class="small" style="margin-top: 8px">
                  <div>
                    {{ d.id_comanda ? `Venda: ${d.id_contador || ''}` : 'Débito Manual' }} - {{d.valor | valor }}
                    <span class="badge badge-dark ml-1" v-if="d.status === '2'">(Pago)</span>
                    <span class="badge badge-danger ml-1" v-else-if="d.vencida === '1'">(Atrasado)</span>
                    <span class="badge badge-success ml-1" v-else>(Aberto)</span>
                  </div>
                  <div>Vencimento: {{d.data_vencimento}}</div>
                  <div v-if="pesquisa.status !== '1'"><b>Recebido:</b> {{d.valor_recebido | valor}}</div>
                </div>
                <div class="small" style="margin-top: 12px">
                  <b>Total: {{ p.total | valor }}</b>
                </div>
                <hr class="hide">
              </div>
            </div>
            <div class="hide">
              <div class="float-right">{{ totalImpressao | valor}}</div>
              <b>Totais</b>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center align-items-center" style="min-height: 300px" v-if="!debitos.length">
          <div v-if="!load">Nenhum débito encontrado</div>
        </div>
      </div>
    </div>
    <div v-show="menu === 4">
      <exportar-relatorio/>
    </div>

    <cliente-debito admin="true"/>
  </div>
</template>

<script>
import TopBar from "@/components/commons/TopBar";
import TipoVendas from "@/components/graficos/TipoPedido";
import TipoPedido from "@/components/graficos/TipoPedido";
import IconCategoria from "@/components/pdv/IconCategoria";
import Loading from "@/components/commons/Loading";
import ModalMenu from "@/components/commons/ModalMenu";
import VendasPagamento from "@/components/graficos/VendasPagamento";
import ExportarRelatorio from "@/views/comanda/relatorio/ExportarRelatorio";
import ComparativoPeriodo from "@/components/graficos/ComparativoPorPeriodo";
import VendasPeriodo from "@/components/graficos/VendasPorPeriodo";
import Tooltip from "@/components/commons/Tooltip";
import ClienteDebito from "@/views/comanda/pdv/ClienteDebito";

export default {
  name: "Relatorios",
  props: ['isComponente'],
  components: {
    ClienteDebito,
    Tooltip,
    VendasPeriodo, ComparativoPeriodo, ExportarRelatorio,
    VendasPagamento, ModalMenu, Loading, IconCategoria, TipoPedido, TipoVendas, TopBar},

  data() {
    return {
      token: localStorage.getItem('key'),
      pagamentos: [],
      vCategorias: [],
      produtos: [],
      tipoComandas: [],
      tipoPedidos: [],
      debitos: [],
      totaisDebitos: { areceber: {}, recebidos: {}, atrasados: {} },
      totalImpressao: 0,
      load: false,
      loadProdutos: false,
      loadCategorias: false,
      diario: {},
      projecao: {},
      frete: {},
      vendasPorPeriodo: [],
      comparativoPorPeriodo: {
        periodo1: [],
        periodo2: [],
      },

      menus: [
        { nome: 'Totais', active: true },
        { nome: 'Produtos', active: true },
        { nome: 'A prazo', active: true },
        { nome: 'Exportar', active: true }
      ],
      menu: 1,

      pesquisa: {
        dt_inicio: new Date().toDateInputValue(),
        dt_fim: new Date().toDateInputValue(),
        id_categoria: '',
        status: '',
        range: '1'
      },

      cache_date: '',
      ocultar: true
    }
  },

  methods: {
    changeEmpresa() {
      if (!this.ocultar) {
        this.cache_date = '';
        this.iniciar();
      }
    },

    iniciar() {
      this.ocultar = false;
      this.loadCategorias = true;
      this.tipoPedidos = [];
      this.tipoComandas = [];
      this.pagamentos = [];
      this.vCategorias = [];
      this.diario = {};
      this.projecao = {};
      this.frete = {};

      if (this.menu === 1) {
        this.$store.state.load = true;
        this.getTotais();

        if (this.pesquisa.range === '4') {
          this.buscarComparativoPorPeriodo();

        } else if (this.pesquisa.range === '6') {
          this.buscarVendasPorPeriodo();
        }

      } else {
        this.produtos = [];
        this.vCategorias = [];
        this.getVendasCategoria();
      }
    },

    changeMenu(m) {
      this.menu = m;

      if (this.menu === 3) {
        this.pesquisa.status = '1';
        this.getDebitos();

      } else if (this.menu === 2) {
        this.iniciar();

      } else {
        this.ocultar = true;
      }
    },

    changeRange(force) {
      if (this.loadCategorias || (this.pesquisa.range === '0' && !force)) {
        return;
      }

      if (['0','99'].includes(this.pesquisa.range)) {
        const dateInput = new Date().toDateInputValue();
        this.pesquisa.dt_inicio = this.pesquisa.dt_inicio || dateInput;
        this.pesquisa.dt_fim = this.pesquisa.range === '0' ? (this.pesquisa.dt_fim || dateInput) : this.pesquisa.dt_inicio;
      }

      this.iniciar();
    },

    getTotais() {
      this.$http.get('comandas/totais-vendas/' + this.token, { params: this.pesquisa })
        .then(response => {
          if (response.data) {
            this.projecao = response.data.projecao || {};
            this.frete = response.data.frete || {};
            const totalDia = parseFloat(response.data.total.valor || '0');
            const ontem = response.data.anterior || {};
            const totalOntem = parseFloat(ontem.valor || '0');

            if (totalDia > 0) {
              this.diario = response.data.total;
              this.diario.ticket = this.diario.valor / this.diario.qtd;

              if (totalOntem > 0) {
                this.diario.percent = ((totalDia / totalOntem - 1) * 100).toFixed();
                const ticketOntem = totalOntem / ontem.qtd;
                this.diario.ticketPercent = ((this.diario.ticket / ticketOntem - 1) * 100).toFixed();
              }

              this.getVendasPedidos();

            } else {
              this.loadCategorias = false;
              this.$store.state.load = false;
              this.saveCache();
            }
          }
        }, res => {
          console.log(res)
          this.loadCategorias = false;
          this.$store.state.load = false;
          this.$swal(res.data.msg || 'Erro temporário');
        });
    },

    getVendasPedidos() {
      this.$http.get('comandas/tipo-comandas/' + this.token, { params: this.pesquisa })
        .then(response => {
          if (response.data) {
            const pedidos = response.data.pedidos || [];
            const tipoPedidos = [
              pedidos.find(p => p.tipo_pedido === '1') || {},
              pedidos.find(p => p.tipo_pedido === '2') || {},
            ]

            this.tipoPedidos = tipoPedidos.map(p => p.qtd || '0');

            const comandas = response.data.comandas || [];
            const tipoComandas = [
              comandas.find(p => p.tipo_comanda === '1') || {},
              comandas.find(p => p.tipo_comanda === '2') || {},
              comandas.find(p => p.tipo_comanda === '3') || {},
              comandas.find(p => p.tipo_comanda === '4') || {},
              comandas.find(p => p.tipo_comanda === '5') || {},
            ]

            this.tipoComandas = tipoComandas.map(p => p.qtd || '0');

          } else {
            this.loadCategorias = false;
            this.$store.state.load = false;
          }

          this.getPagamentos();

        }, res => {
          this.loadCategorias = false;
          this.$store.state.load = false;
          this.$swal(res.data.msg || 'Erro temporário');
        });
    },

    getPagamentos() {
      this.$http.get('comandas/vendas-pagamentos/' + this.token, { params: this.pesquisa })
        .then(response => {
          if (response.data) {
            this.pagamentos = response.data || [];
          }

          this.loadCategorias = false;
          this.$store.state.load = false;
          this.saveCache();

        }, res => {
          this.loadCategorias = false;
          this.$store.state.load = false;
          this.$swal(res.data.msg || 'Erro temporário');
        });
    },

    getVendasCategoria() {
      this.loadCategorias = true;
      this.loadProdutos = true;

      this.$http.get('comandas/vendas-categorias/' + this.token, { params: this.pesquisa })
        .then(response => {
          this.loadCategorias = false;
          this.vCategorias = response.data;
          this.maisVendidos();

        }, res => {
          this.loadCategorias = false;
          this.loadProdutos = false;
          this.$swal(res.data.msg || 'Erro temporário');
        });
    },

    maisVendidos(msg) {
      this.produtos = [];
      this.loadProdutos = true;
      this.$http.get('comandas/vendas-top-produtos/' + this.token, { params: this.pesquisa })
        .then(response => {
          this.loadProdutos = false;
          this.produtos = response.data;

          if (msg && !this.produtos.length) {
            this.$swal('Você não tem vendas neste dia!');
          }

        }, res => {
          this.loadProdutos = false;
          this.$swal(res.data.msg || 'Erro temporário');
        });
    },

    buscarComparativoPorPeriodo() {
      this.load = true;
      this.$http.get('comandas/comparativo-por-periodo/'  + this.token + '/?periodo1=1&periodo2=2')
        .then(response => {
          this.comparativoPorPeriodo = response.data;

        }, res => {
          this.load = false;
          this.$swal(res.data.msg || 'Erro relatorio comparitivo de periodos');
        });
    },

    buscarVendasPorPeriodo() {
      this.$http.get('comandas/vendas-por-periodo/'  + this.token + '/?periodo=3')
        .then(res => {
          this.vendasPorPeriodo = res.data;

        }, res => {
          this.load = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
        });
    },

    saveCache() {
      if (this.pesquisa.range === '1') {
        this.cache_date = Date.now();
        sessionStorage.setItem('cache_home', JSON.stringify(this.$data));

      } else {
        sessionStorage.removeItem('cache_home');
      }
    },

    getDebitos() {
      this.totaisDebitos = { areceber: {}, recebidos: {}, atrasados: {} };
      this.debitos = [];
      this.totalImpressao = 0;
      this.load = true;
      this.$store.state.load = true;

      if (this.pesquisa.status === '3') {
        const dateInput = new Date().toDateInputValue();
        this.pesquisa.dt_inicio = dateInput;
        this.pesquisa.dt_fim = dateInput;
      }

      this.$http.get('comandas/debitos/' + this.token, { params: this.pesquisa })
        .then(response => {
          this.load = false;
          this.$store.state.load = false;
          this.debitos = this.agruparDebitosClientes(response.data.debitos || []);
          this.totalImpressao = this.debitos.length ? this.debitos.reduce((acc, obj) => acc + obj.total, 0) : 0;

          this.totaisDebitos = {
            areceber: response.data.areceber || {},
            recebidos: response.data.recebidos || {},
            atrasados: response.data.atrasados || {}
          }

        }, res => {
          this.load = false;
          this.$store.state.load = false;
          this.$swal(res.data.msg || 'Erro temporário');
        });
    },

    agruparDebitosClientes(debitos) {
      const agrupadoPorCliente = {};

      debitos.forEach(debito => {
        const id = debito.id_cliente;
        if (!agrupadoPorCliente[id]) {
          agrupadoPorCliente[id] = {
            id_cliente: debito.id_cliente,
            nome_cliente: debito.nome_cliente,
            telefone: debito.telefone,
            total: 0,
            debitos: []
          };
        }

        agrupadoPorCliente[id].total += parseFloat(debito.valor);
        agrupadoPorCliente[id].debitos.push(debito);
      });

      return Object.values(agrupadoPorCliente);
    },

    abrirDebito(dados) {
      this.$emit('openDebitos', { id_cliente: dados.id_cliente, nome_cliente: dados.nome_cliente });
    },

    imprimirDebitos() {
      let html = document.getElementById("relatorioDebitos");

      if (html) {
        html = html.cloneNode(true);
        html.querySelectorAll('.d-print-none').forEach(el => el.remove());
        let content = html.innerHTML.replace(/\sdata-v-[a-z0-9\-]+="[^"]*"/gi, '').replace(/<!--[\s\S]*?-->/g, '').trim();
        const cf = this.$store.state.impressora;
        const device = cf.devicePdv || null;
        const dataImpressao = {
          content,
          copies: 1,
          isPdv: true,
          status: 1,
          nome_documento: 'Relatório Débitos',
          zoom: "9px",
          device,
          impressora: {
            device,
            zoom: "9px",
            largura: cf.largura || '100%'
          }
        };

        this.$helpers.imprimirComprovante(this, localStorage.getItem('token'), [dataImpressao], cf.mobilePrint);
      }
    },

    ocultarInfos() {
      if (!this.ocultar) {
        this.ocultar = true;

        if (!this.usuario.admin) {
          this.menus[1].active = false;
          this.menus[2].active = false;
        }

      } else {
        this.$helpers.confirmarSenhaAdm(this, () => {
          this.ocultar = false;
          this.menus[1].active = true;
          this.menus[2].active = true;

          if (!this.cache_date) {
            this.iniciar();
          }
        });
      }
    }
  },

  mounted() {
    if (this.usuario.id_funcao < 3) {
      const cache = JSON.parse(sessionStorage.getItem('cache_home'));

      if (cache && cache.cache_date && ((Date.now() - cache.cache_date)/60/1000) < 10) {
        this.projecao = cache.projecao;
        this.frete = cache.frete;
        this.diario = cache.diario;
        this.tipoPedidos = cache.tipoPedidos;
        this.tipoComandas = cache.tipoComandas;
        this.pagamentos = cache.pagamentos;
        this.cache_date = cache.cache_date;
      }
    }

    if (!this.usuario.admin) {
      this.menus[1].active = false;
      this.menus[3].active = false;
    }
  },

  computed: {
    usuario() {
      return this.$store.state.dataUser
    },

    categorias() {
      return this.$store.state.categorias
    }
  },

  filters: {
    fixed (value) {
      return value ? Number(value) : 0
    },

    valor(value) {
      if (value !== null && value !== undefined) {
        const v = parseFloat(value);
        return 'R$ ' + parseFloat(v.toFixed(2)).toLocaleString('pt-br', {minimumFractionDigits: 2});

      } else  {
        return 'R$ ' + parseFloat('0').toFixed(2);
      }
    }
  }
}
</script>

<style scoped>
.card {
  border-radius: 16px;
  border: none;
}
.card .card-body {
  padding: 18px;
}

.totais .card {
  padding: 4px 0;
}

.img-pagamento {
  display: flex;
  justify-content: space-between;
  margin: 16px auto 0;
  height: 28px;
}

.img-pagamento img {
  width: 18px;
}

.card-categorias {
  height: 389px
}

.debito-list {
  cursor: pointer;
  border-bottom: 1px solid #e3e6f0;
  padding-bottom: 6px;
  margin-bottom: 12px;
}

.debito-list:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 6px;
}

.icon-dot {
  font-size: 10px;
  margin-right: 3px;
}

@media (max-width: 767px) {
  .card .card-body {
    padding: 13px;
  }

  .card-categorias {
    height: auto;
  }
}

.borderless:last-child {
  border: none!important;
}

.table th {
  border-top: none;
}

</style>
